const MAP002 = [
  {
    name: "K5-Wang",
    lat: 27.503237,
    lng: 89.899757,
    description:
      "<table><tr><td>Country</td><td>Bhutan</td></tr><tr><td>City</td><td>Wangdue</td></tr><tr><td>Type</td><td>Seismic/GNSS station (BBS+SMA+GNSS)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>June 2017</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "K5-Trong",
    lat: 27.497847,
    lng: 90.509241,
    description:
      "<table><tr><td>Country</td><td>Bhutan</td></tr><tr><td>City</td><td>Trongsa</td></tr><tr><td>Type</td><td>Seismic/GNSS station (BBS+SMA+GNSS)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>April 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "K5-Mong",
    lat: 27.260258,
    lng: 91.156708,
    description:
      "<table><tr><td>Country</td><td>Bhutan</td></tr><tr><td>City</td><td>Mongar</td></tr><tr><td>Type</td><td>Seismic/GNSS station (BBS+SMA+GNSS)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>April 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Under maintenance</td></tr></table>",
  },
  {
    name: "K5-Haa",
    lat: 27.41556,
    lng: 89.25167,
    description:
      "<table><tr><td>Country</td><td>Bhutan</td></tr><tr><td>City</td><td>Haa</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>April 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "K5-Chuk",
    lat: 27.08861,
    lng: 89.53889,
    description:
      "<table><tr><td>Country</td><td>Bhutan</td></tr><tr><td>City</td><td>Chukha</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>April 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Under maintenance</td></tr></table>",
  },
  {
    name: "K5-Gasa",
    lat: 27.9106,
    lng: 89.731,
    description:
      "<table><tr><td>Country</td><td>Bhutan</td></tr><tr><td>City</td><td>Gasa</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>April 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "K5-Zhem",
    lat: 27.411,
    lng: 90.411,
    description:
      "<table><tr><td>Country</td><td>Bhutan</td></tr><tr><td>City</td><td>Zhemgang</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>April 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "K5-Lhun",
    lat: 27.671,
    lng: 91.1844,
    description:
      "<table><tr><td>Country</td><td>Bhutan</td></tr><tr><td>City</td><td>Lhuntse</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>April 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "MM-KTA",
    lat: 24.179362,
    lng: 96.340193,
    description:
      "<table><tr><td>Country</td><td>Myanmar</td></tr><tr><td>City</td><td>Katha</td></tr><tr><td>Type</td><td>Seismic/GNSS station (BBS+SMA+GNSS)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Global -IRIS</td></tr><tr><td>Date of establishment</td><td>August 2017</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "MM-NGU",
    lat: 21.205721,
    lng: 94.916652,
    description:
      "<table><tr><td>Country</td><td>Myanmar</td></tr><tr><td>City</td><td>Ngaung U</td></tr><tr><td>Type</td><td>Seismic/GNSS station (BBS+SMA+GNSS)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Global -IRIS</td></tr><tr><td>Date of establishment</td><td>August 2017</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "MM-TGI",
    lat: 20.768546,
    lng: 97.034076,
    description:
      "<table><tr><td>Country</td><td>Myanmar</td></tr><tr><td>City</td><td>Taung Gyi</td></tr><tr><td>Type</td><td>Seismic station (BBS+SMA)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Global -IRIS</td></tr><tr><td>Date of establishment</td><td>August 2017</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "MM-NPY",
    lat: 19.778922,
    lng: 96.137635,
    description:
      "<table><tr><td>Country</td><td>Myanmar</td></tr><tr><td>City</td><td>Nay Pyi Taw</td></tr><tr><td>Type</td><td>GNSS station (GNSS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>April 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "MM-HPW",
    lat: 22.627716,
    lng: 97.303569,
    description:
      "<table><tr><td>Country</td><td>Myanmar</td></tr><tr><td>City</td><td>Hsipaw</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>April 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "MM-GWA",
    lat: 17.601682,
    lng: 94.583141,
    description:
      "<table><tr><td>Country</td><td>Myanmar</td></tr><tr><td>City</td><td>Gwa</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>April 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "MM-DWI",
    lat: 14.079778,
    lng: 98.209618,
    description:
      "<table><tr><td>Country</td><td>Myanmar</td></tr><tr><td>City</td><td>Dawei</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>April 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "MM-KBU",
    lat: 23.205264,
    lng: 95.523485,
    description:
      "<table><tr><td>Country</td><td>Myanmar</td></tr><tr><td>City</td><td>Kanbalu</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>April 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "MM-TGO",
    lat: 18.929338,
    lng: 96.447441,
    description:
      "<table><tr><td>Country</td><td>Myanmar</td></tr><tr><td>City</td><td>Taungoo</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>April 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "MM-MWY",
    lat: 16.680801,
    lng: 98.507102,
    description:
      "<table><tr><td>Country</td><td>Myanmar</td></tr><tr><td>City</td><td>Myawaddy</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>October 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "MM-MEK",
    lat: 12.443283,
    lng: 98.603667,
    description:
      "<table><tr><td>Country</td><td>Myanmar</td></tr><tr><td>City</td><td>Myeik</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>October 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "RM-SIM",
    lat: 20.133,
    lng: 92.885333,
    description:
      "<table><tr><td>Country</td><td>Myanmar</td></tr><tr><td>City</td><td>Sittwe</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Global -IRIS</td></tr><tr><td>Date of establishment</td><td>April 2008 (under the RM network code)</td></tr><tr><td>Source of Funds</td><td>UNESCAP2</td></tr><tr><td>Status</td><td>Under maintenance</td></tr></table>",
  },
  {
    name: "NK-DANG",
    lat: 27.95081,
    lng: 82.491127,
    description:
      "<table><tr><td>Country</td><td>Nepal</td></tr><tr><td>City</td><td>Dang Ghorahi</td></tr><tr><td>Type</td><td>Seismic/GNSS station (BBS+SMA+GNSS)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>September 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Under maintenance</td></tr></table>",
  },
  {
    name: "NK-MAHO",
    lat: 27.005113,
    lng: 85.868771,
    description:
      "<table><tr><td>Country</td><td>Nepal</td></tr><tr><td>City</td><td>Bardibas</td></tr><tr><td>Type</td><td>Seismic/GNSS station (BBS+SMA+GNSS)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Shared with RIMES only</td></tr><tr><td>Date of establishment</td><td>September 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS1</td></tr><tr><td>Status</td><td>Under maintenance</td></tr></table>",
  },
  {
    name: "RM-SZP",
    lat: 17.552,
    lng: 120.455,
    description:
      "<table><tr><td>Country</td><td>Philippines</td></tr><tr><td>City</td><td>Santa Ilocos Sur</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>satellite telemetry</td></tr><tr><td>Data Transmission</td><td>Global -IRIS</td></tr><tr><td>Date of establishment</td><td>April 2008 (under the RM network code)</td></tr><tr><td>Source of Funds</td><td>UNESCAP2</td></tr><tr><td>Status</td><td>Under maintenance</td></tr></table>",
  },
  {
    name: "RM-DLV",
    lat: 11.965167,
    lng: 108.4815,
    description:
      "<table><tr><td>Country</td><td>Vietnam</td></tr><tr><td>City</td><td>Dalat</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Global -IRIS</td></tr><tr><td>Date of establishment</td><td>April 2008 (under the RM network code)</td></tr><tr><td>Source of Funds</td><td>UNESCAP2</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "RM-SLV",
    lat: 21.333833,
    lng: 103.905,
    description:
      "<table><tr><td>Country</td><td>Vietnam</td></tr><tr><td>City</td><td>Son La</td></tr><tr><td>Type</td><td>Seismic station (BBS only)</td></tr><tr><td>Operation</td><td>cellular telemetry</td></tr><tr><td>Data Transmission</td><td>Global -IRIS</td></tr><tr><td>Date of establishment</td><td>April 2008 (under the RM network code)</td></tr><tr><td>Source of Funds</td><td>UNESCAP2</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
]

export default MAP002
